var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChatInboxRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.032 16.25a22.8 22.8 0 0 0 6.3 3.51.938.938 0 0 0 1.222-1.14q-.66-2.286-.961-4.02A6.86 6.86 0 0 0 20 9.376v-2.5A6.875 6.875 0 0 0 13.125 0h-6.25A6.875 6.875 0 0 0 0 6.875v2.5a6.875 6.875 0 0 0 6.875 6.875zm.608-1.113L11.47 15H6.874A5.625 5.625 0 0 1 1.25 9.375v-2.5A5.625 5.625 0 0 1 6.875 1.25h6.25a5.625 5.625 0 0 1 5.625 5.625v2.5a5.61 5.61 0 0 1-2.212 4.472l-.296.226.058.367q.268 1.708.883 3.927a21.6 21.6 0 0 1-5.543-3.23M10 6.25H5V7.5h5zm5 2.5H5V10h10z"
})));
export default SvgChatInboxRight;